import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageStore } from './store/languageStore';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { router } from './routes';
import './i18n/config';

function App() {
  const { i18n } = useTranslation();
  const { language, isRTL } = useLanguageStore();

  useEffect(() => {
    i18n.changeLanguage(language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language, isRTL, i18n]);

  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}

export default App;
